module.exports = __webpack_public_path__ + "static/3-fa5a7ba21cdcdeddee17e30c19cc5475.png";